import React, { useEffect, useState } from 'react';
import { Step, StepIconProps, Stepper, Typography } from '@mui/material';
import { StepLabelProps } from '@mui/material/StepLabel/StepLabel';
import {
  StyledConnector,
  StyledStepIcon,
  StyledStepLabel,
  StyledWizardWrapper,
} from './styles';

interface IWizardStepper {
  steps: string[];
  activeStep: number;
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
}

const StepIcon = (props: StepIconProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { active, completed, className, icon, error } = props;

  const getClassName = () => {
    if (error) {
      return 'step-icon-error';
    }
    if (active) {
      return 'step-icon-active';
    }
    if (completed) {
      return 'step-icon-completed';
    }

    return '';
  };

  return <StyledStepIcon className={`${className} ${getClassName()}`}>{icon}</StyledStepIcon>;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const WizardStepper = ({ steps, activeStep, setActiveStep }: IWizardStepper) => {
  const [stepErrors, setStepErrors] = useState<{ [key: number]: any }>({});

  useEffect(() => {
    const handler = (event: any) => {
      const newErrors = event?.detail?.data || {};
      setStepErrors(newErrors);
    };
    document.addEventListener('setStepErrorsEvent', handler);

    return () => {
      document.removeEventListener('setStepErrorsEvent', handler);
    };
  }, []);
  const isStepFailed = (step: number) => !!stepErrors?.[step];

  return (
    <StyledWizardWrapper>
      <Typography variant="h5">Certificate to Possess a Shotgun</Typography>
      <Stepper activeStep={activeStep} alternativeLabel connector={<StyledConnector />}>
        {steps.map((label, index) => {
          const labelProps: StepLabelProps = {};
          if (isStepFailed(index)) {
            labelProps.error = true;
          }

          return (
            <Step key={label} className={labelProps?.error ? 'step-error' : ''}>
              <StyledStepLabel {...labelProps} StepIconComponent={StepIcon}>
                {label}
              </StyledStepLabel>
            </Step>
          );
        })}
      </Stepper>
    </StyledWizardWrapper>
  );
};

export { WizardStepper };
